module.exports = __webpack_public_path__ + "img/sign-out-pink.16c3b25e.svg";